/* ==========================================================================
   wow-marca.js — alinea el color del botón de la app de contra entrega.

   Releasit escribe sus colores en el atributo style con !important, y contra
   eso ninguna hoja de estilos puede competir: el style en línea siempre gana.
   Por eso aquí se reescriben esas cuatro propiedades y nada más.

   ⚠️ Esto es un parche. El arreglo de fondo es cambiar el color en los
   ajustes de Releasit (Buy Now Button → Style) y borrar este archivo.
   ========================================================================== */
(function () {
  var NARANJA = "#FF4D00";
  var TINTA = "#0A0A0A";

  function alinear(boton) {
    if (boton.dataset.wowAlineado === "1") return;
    boton.style.setProperty("background", NARANJA, "important");
    boton.style.setProperty("color", TINTA, "important");
    boton.style.setProperty("border", "1px solid " + NARANJA, "important");
    boton.style.setProperty("border-radius", "0", "important");
    boton.style.setProperty("box-shadow", "none", "important");
    boton.dataset.wowAlineado = "1";
  }

  function barrer() {
    document.querySelectorAll("._rsi-buy-now-button").forEach(alinear);
  }

  barrer();
  document.addEventListener("DOMContentLoaded", barrer);

  // La app monta sus botones en diferido y vuelve a pintarlos al navegar.
  if (window.MutationObserver) {
    new MutationObserver(barrer).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
